import { render, staticRenderFns } from "./SimpleForm.vue?vue&type=template&id=5e56074e&scoped=true&"
import script from "./SimpleForm.vue?vue&type=script&lang=js&"
export * from "./SimpleForm.vue?vue&type=script&lang=js&"
import style0 from "./SimpleForm.vue?vue&type=style&index=0&id=5e56074e&scoped=true&lang=scss&"
import style1 from "./SimpleForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e56074e",
  null
  
)

export default component.exports